import {ProteinSpecifier} from 'analyses/protein-alignment/util/ProteinAlignmentConstants';
import {Permissions} from 'auth/PermissionConstants';
import {ProteinSummary, Protein} from 'molbio/proteins/util/ProteinConstants';

/**
 * Given a protein model, create a protein specifier (which specifies a row to use in a protein
 * alignment) that specifies that that protein should be used.
 */
export default function specifierForProtein(
  protein: (ProteinSummary | Protein) & {permissions: Permissions}
): ProteinSpecifier {
  return {
    id: protein.id,
    name: protein.name,
    canBeTemplate: Boolean(protein.permissions.polymerFeaturesEditable),
  };
}
